import { Category, FinancialEntry, Sheet } from "@/types/finance";
import { MonthYear } from "@/types/monthYear";
import { financialEntriesApiV2, sheetsApiV2 } from "./apiV2";

const CATEGORIES_KEY = "finance_categories";
const VALUES_KEY = "finance_values";
const SHEETS_KEY = "finance_sheets";

export const FinanceService = {
  getCategories(): Category[] {
    const saved = localStorage.getItem(CATEGORIES_KEY);
    return saved ? JSON.parse(saved) : [];
  },

  saveCategories(categories: Category[]) {
    localStorage.setItem(CATEGORIES_KEY, JSON.stringify(categories));
  },

  async getSheets(): Promise<Sheet[]> {
    let tt = await sheetsApiV2.getAll();
    return tt;
  },

  saveSheets(sheets: Sheet[]) {
    localStorage.setItem(SHEETS_KEY, JSON.stringify(sheets));
  },

  async getMonthlyValues(sheetId: string): Promise<FinancialEntry[]> {
    const values = await financialEntriesApiV2.getAll(sheetId);
    return values;
  },

  saveMonthlyValues(values: FinancialEntry[]) {
    localStorage.setItem(VALUES_KEY, JSON.stringify(values));
  },

  calculateCategorySum(
    catId: string,
    categories: Category[],
    monthlyValues: FinancialEntry[],
    monthYear: MonthYear,
    sheetId: string
  ): number {
    const directValue =
      monthlyValues.find(
        (v) =>
          v.category_id === catId &&
          v.year === monthYear.year &&
          v.month + 1 === monthYear.month &&
          v.sheet_id === sheetId
      )?.amount || 0;

    const children = categories.filter((c) => c.parentId === catId);
    if (children.length === 0) return directValue;

    return children.reduce(
      (acc, child) =>
        acc +
        this.calculateCategorySum(
          child.id,
          categories,
          monthlyValues,
          monthYear,
          sheetId
        ),
      0
    );
  },

  isDescendant(
    parentId: string,
    childId: string,
    categories: Category[]
  ): boolean {
    const child = categories.find((c) => c.id === childId);
    if (!child || !child.parentId) return false;
    if (child.parentId === parentId) return true;
    return this.isDescendant(parentId, child.parentId, categories);
  },

  getIdsToDelete(catId: string, categories: Category[]): string[] {
    const children = categories.filter((c) => c.parentId === catId);
    const childIds = children.flatMap((child) =>
      this.getIdsToDelete(child.id, categories)
    );
    return [catId, ...childIds];
  },
};
